import { NgModule } from "@angular/core";
import { LoadingOverlayComponent } from "./loading-overlay/loading-overlay.component";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";

const modules = [LoadingOverlayComponent, LoadingSpinnerComponent]

@NgModule({
  declarations: modules,
  imports: [],
  exports: modules
})
export class LoadingModule { }
